<script setup lang="ts">
import { useIsNextLayout } from '@/utils/composables/useLayoutVariant';

const isNextLayout = useIsNextLayout();
</script>

<template>
  <div class="content" :class="{ 'is-next-layout': isNextLayout }">
    <div class="content-body">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  width: max-content;
  margin: 0 auto;
  .content-body {
    width: var(--layout-content-width, 948px);
    padding: 24px 0 0 8px;
    margin-left: 8px;
  }

  &.is-next-layout {
    width: 100%;
    margin: 0;

    .content-body {
      padding: 24px 0 0;
      margin: 0 auto;
    }
  }
}
</style>
